var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "313px",
    viewBox: "0 0 360 313",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 360,
    height: 313
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mob",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-/-email",
    transform: "translate(-1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#E4E9ED",
    mask: "url(#mask-2)",
    cx: 369,
    cy: 235,
    r: 78
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    stroke: "#E4E9ED",
    strokeWidth: 10,
    mask: "url(#mask-2)",
    cx: -15,
    cy: -12,
    r: 79
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSide);
export default __webpack_public_path__ + "static/media/rightSide.9ccd276d504afdc3d9f30427d150d37b.svg";
export { ForwardRef as ReactComponent };